<template>
	<div
		class="g-block-title-article g-block-title-padding"
		:class="{
			'g-block-title-article--edit': editable,
			'is-active': editable && active,
			'g-block-title-article--h5': h5,
			'g-block-title-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-title-article__content">
			<div class="g-block-title-article__part g-block-title-article__part--primary" :style="{ color: themeColor }">
				<RichTextEditable
					v-if="editable"
					class="g-block-title-article__text g-block-title-article__text--primary"
					fit-content
					:model-value="data.primaryText"
					placeholder="文章标题"
					@update:model-value="onPrimaryUpdate"
					@focus="onWrapClick"
				/>
				<div
					v-else
					class="g-block-title-article__text g-block-title-article__text--primary"
					v-html="data.primaryText || ''"
				></div>
			</div>
			<div class="g-block-title-article__part g-block-title-article__part--meta" :style="{ color: lightColor }">
				<RichTextEditable
					v-if="editable"
					class="g-block-title-article__text g-block-title-article__text--meta"
					fit-content
					:model-value="data.metaText"
					placeholder="作者 2023-11-04 23:14 发表于浙江"
					@update:model-value="onMetaUpdate"
					@focus="onWrapClick"
				/>
				<div
					v-else
					class="g-block-title-article__text g-block-title-article__text--meta"
					v-html="data.metaText || ''"
				></div>
			</div>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { dualTitleMixin } from '../shared/dualTitleMixin.js';

	export default {
		name: 'GBlockTitleArticle',
		components: { RichTextEditable },
		mixins: [dualTitleMixin],
		methods: {
			onMetaUpdate(metaText) {
				this.$emit('update', { metaText });
			},
		},
	};
</script>

<style scoped lang="less">
	.g-block-title-article {
		&--edit {
			border: 1px solid transparent;
			border-radius: 4px;
			transition: border-color 0.2s, box-shadow 0.2s;
			cursor: pointer;

			&.is-active {
				border-color: #285af9;
				box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.15);
			}
		}
	}

	.g-block-title-article__content {
		display: flex;
		flex-direction: column;
		gap: 8px;
		text-align: left;
	}

	.g-block-title-article__text {
		display: inline-flex;
		line-height: 1.3;
		padding: 0;
		font-family: inherit;
		word-break: break-word;
		white-space: pre-wrap;
		color: inherit;

		&--primary {
			font-size: 24px;
			font-weight: 700;
		}

		&--meta {
			font-size: 13px;
			font-weight: 400;
		}

		:deep(.g-rich-text-editable) {
			display: inline-flex;
			width: auto;
			max-width: 100%;
			color: inherit;
		}

		:deep(.g-rich-text-editable__content) {
			line-height: 1.3;
			min-height: unset;
			padding: 0;
			color: inherit;
		}

		:deep(span),
		:deep(font),
		:deep(p),
		:deep(div) {
			margin: 0;
			padding: 0;
			color: inherit;
		}
	}

	.g-block-title-article--h5 {
		.g-block-title-article__content {
			gap: 0.16rem;
		}

		.g-block-title-article__text--primary {
			font-size: 0.48rem;
		}

		.g-block-title-article__text--meta {
			font-size: 0.26rem;
		}
	}
</style>
